export default {
  "b2b.smlouvy-grid.add": "Přidat smlouvu",
  "b2b.smlouvy-grid.title": "Smlouvy",
  "b2b.smlouvy-grid.delete-dialog.title": "Smazání smlouvy",
  "b2b.smlouvy-grid.delete-dialog.confirm": "Opravdu chcete smazat smlouvu?"
};
